export const CurrencySymbols = {
  USD: '$',
  GBP: '£',
  EUR: '€',
  JPY: '¥',
  CAD: 'CA $',
  AUD: 'AU $',
  BTC: '₿',
} as Record<string, string>;
